module.exports = __webpack_public_path__ + "static/media/Efficient.27f25754.png";